module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-6.82cf48c4.png";